export type Color =
  | 'primary'
  | 'slate'
  | 'gray'
  | 'zinc'
  | 'neutral'
  | 'stone'
  | 'red'
  | 'orange'
  | 'amber'
  | 'yellow'
  | 'lime'
  | 'green'
  | 'emerald'
  | 'teal'
  | 'cyan'
  | 'sky'
  | 'blue'
  | 'indigo'
  | 'violet'
  | 'purple'
  | 'fuchsia'
  | 'pink'
  | 'rose'
  | 'white'
  | 'black'
  | 'center'
  | 'personal'
  | 'treatment'
  | 'supplement'
  | 'counseling';
export const Colors: Color[] = [
  'primary',
  'slate',
  'gray',
  'zinc',
  'neutral',
  'stone',
  'red',
  'orange',
  'amber',
  'yellow',
  'lime',
  'green',
  'emerald',
  'teal',
  'cyan',
  'sky',
  'blue',
  'indigo',
  'violet',
  'purple',
  'fuchsia',
  'pink',
  'rose',
  'white',
  'black',
];

export type Size = 'xs' | 'sm' | 'md' | 'lg' | 'xl';
export type Rounded = 'none' | 'sm' | 'md' | 'lg' | 'xl' | '2xl' | 'full';
export type Variant = 'solid' | 'outline' | 'ghost' | 'light';

export type Align = 'asc' | 'desc';

export type PageInfo = {
  pageItems?: number;
  pageNo?: number;
  pageSize?: number;
  totalItems?: number;
  totalPages?: number;
};
